import React from 'react'
import classNames from 'classnames'

// The only sanctioned writer of the `field` class (lint-enforced); styled by
// theme.scss.
/**
 * @import import { FormField } from '@/components/forms/FormField'
 * @param {object} props
 * @param {node} [props.label] Label rendered above the control, or beside it with `inline`
 * @param {boolean} [props.required] Marks the label with the required asterisk
 * @param {boolean} [props.error] Critical border on the wrapped text input or textarea
 * @param {boolean} [props.disabled] Blocks interaction and dims the label
 * @param {boolean} [props.inline] Lays the label and control out side by side
 * @param {number} [props.span] Columns (of 12) the field spans inside a FormFieldGrid
 * @param {string} [props.className] Additional classes on the field element
 * @param {node} [props.children] The form control(s) the field wraps
 */
export const FormField = ({
  label,
  required,
  error,
  disabled,
  inline,
  span,
  className,
  children,
  ...props
}) => (
  <div
    className={classNames(
      // eslint-disable-next-line no-restricted-syntax
      'field',
      { required, error, disabled, inline },
      span && `span-${span}`,
      className
    )}
    {...props}
  >
    {label && <label>{label}</label>}
    {children}
  </div>
)
